import { SERVICEURI } from "../const/serviceuri";
import { mapResponseToSessionData } from "./mapper/sessiondatamapper";
import { fetchFrameworkApiInstance, getFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';

const getDistributors = async (userId: string , filterQuery: any = '') => {
    try {
        let endPoint = SERVICEURI.GetDistributorList.replace("{userid}", userId) + filterQuery;
        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const getCustomers = async (userId: string, distCode: string, isSave: string = 'false') => {
    try {
        let endPoint = SERVICEURI.GetCustomerList.replace("{userid}", userId)
            .replace("{distcode}", distCode).replace("{isSave}", isSave);
        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const getLocation = async (userId: string, distCode: string, custCode: string, isSave: string = 'false') => {
    try {
        let endPoint = SERVICEURI.GetLocationList.replace("{userid}", userId)
            .replace("{distcode}", distCode).replace("{custcode}", custCode).replace("{isSave}", isSave);
        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};


const getCustomersByMultipleDistcode = async (userId: string, distCode: string, isSave: string = 'false') => {
    try {
        let endPoint = SERVICEURI.GetCustomerListByMultipleDistCode.replace("{userid}", userId)
            .replace("{distcode}", distCode).replace("{isSave}", isSave);

        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const getLocationByMultipleCustCode = async (userId: string, custCode: string, isSave: string = 'false') => {
    try {
        let endPoint = SERVICEURI.GetLocationListByMultipleCustCode.replace("{userid}", userId)
            .replace("{custcode}", custCode).replace("{isSave}", isSave);

        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const getSessionData = async (userId: string) => {
    try {
        let endPoint = SERVICEURI.GetorSetSessionData.replace("{userid}", userId);
        const response = await getFrameworkApiInstance(endPoint);
        let sessionData = mapResponseToSessionData(response);
        return sessionData;
    } catch (error) {
        throw error;
    }
};

const setSessionData = async (userId: string, sessionData: any) => {
    try {
        let endPoint = SERVICEURI.GetorSetSessionData.replace("{userid}", userId);
        const response = await fetchFrameworkApiInstance(sessionData, endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};

const clearSessionData = async (userId: string) => {
    try {
        let endPoint = SERVICEURI.clearSessionData.replace("{userid}", userId);
        const response = await getFrameworkApiInstance(endPoint);
        let sessionData = mapResponseToSessionData(response);
        return sessionData;
    } catch (error) {
        throw error;
    }
};

const fetchQuickLinks = async (userId: string) => {
    try {
        let endPoint = SERVICEURI.GetQuickLinks?.replace("{userId}", userId);
        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};


export default
    {
        getDistributors, getCustomers, getLocation, getSessionData, setSessionData, fetchQuickLinks, getCustomersByMultipleDistcode, getLocationByMultipleCustCode, clearSessionData
    }